import React, { Component } from 'react'
import injectSheet from 'react-jss'
import Color from 'color'
import { Redirect, withRouter, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { flexUtils, palette } from '../../Theme/Theme'
import * as Actions from '../../Actions/Actions'
// import ReactGA from 'react-ga'
import Responsive from 'react-responsive'


const Desktop = props => <Responsive {...props} minWidth={736}/>
const Mobile = props => <Responsive {...props} maxWidth={735}/>

class AccountInfo extends Component {
    constructor () {
        super()
        this.state ={
            autoPlay: true,
            marginLeft: 5,
            sliderThumbColor: palette.white,
            sliderColor: Color(palette.white).darken(0.3)
        }
        this.toggleSlider = this.toggleSlider.bind(this)
    }
    render() {
        
        let sliderColor = this.state.sliderColor
        let marginLeft = this.state.marginLeft
        if (!this.props.logged) {
            return <Redirect to='/'/>
        }
        if (this.props.autoPlay){
            marginLeft = 50, 
            sliderColor = Color(palette.orange)
        }
        const { classes, user } = this.props
        const { Body, Label, InfoItem, EditButton } = classes
        const { firstName, lastName, email } = user
        return (
            <div className={Body}>
                <span>
                    <div className={Label}>
                        User Info
                    </div>
                    <div className={InfoItem}>
                        <span>{firstName} {lastName}</span>
                        <span className={EditButton} onClick={this.changeName}>Change Name</span>
                    </div>
                    <div className={InfoItem}>
                        <span>{email}</span>
                        <span className={EditButton} onClick={this.changeEmail}>Change Email</span>
                    </div>
                    <div className={InfoItem}>
                        <span>******</span>
                        <span className={EditButton} onClick={this.changePassword}>Change Password</span>
                    </div>
                </span>

                <span>
                    <div className={Label}>
                        Video Playback Settings
                    </div>   
                    <div className={InfoItem}>
                        <div>Extended AutoPlay</div>
                        <div className={classes.customSliderContainer}>
                            <div style={{backgroundColor: `${sliderColor}`}} className={classes.slider} onClick={this.toggleSlider}>
                                <div style={{marginLeft: `${marginLeft}%`, backgroundColor: this.state.sliderThumbColor}} className={classes.sliderThumb}></div>
                            </div>
                        </div>                        
                    </div>
                    <div style={{justifyContent: 'center', color: 'rgb(120, 120, 120)'}} className={InfoItem}>
                    * This setting will only apply to Web Player and will not change your device (Roku/AppleTV) playback settings.
                    </div>
                </span>

                <span>
                    <div className={Label}>
                        Plan and Payment
                    </div>
                    <Desktop>
                        {this.renderPlanInfo()}
                    </Desktop>          
                    <Mobile>
                        {this.renderPlanInfoMobile()}
                    </Mobile>          
                    {this.renderMisc()}
                </span>
            </div>
        )
    }

    toggleSlider () {
        // console.log(this.props.autoPlay)
        if (this.props.autoPlay) {
            this.setState({marginLeft: 5, sliderColor: Color(palette.white).darken(0.3)})
            this.props.dispatch(Actions.toggleAutoPlay(false))
        } else {
            this.props.dispatch(Actions.toggleAutoPlay(true))
            this.setState({marginLeft: 50, sliderColor: Color(palette.orange)})
        }                
    }

    componentDidMount () {
        // ReactGA.pageview('/AccountInfo');
    }        

    changeName = () => {
        this.props.history.push('/Home/EditName')
    }

    changeEmail = () => {
        this.props.history.push('/Home/EditEmail')
    }

    changePassword = () => {
        this.props.history.push('/Home/EditPassword')
    }

    changePlan = () => {
        console.log('test')
        this.props.history.push('/Home/EditPlan')
    }

    unsubscribe = () => {
        this.props.history.push('/Home/Unsubscribe')
    }

    changePaymentMethod = () => {
        this.props.history.push('/Home/EditPaymentMethod')
    }

    enterCoupon = () => {
        this.props.history.push('/Home/Coupon')
    }

    signOut = () => {
        const { dispatch, history } = this.props
        dispatch(Actions.signOut(history))
    }

    renderPlanName = (plan) => {
        switch (plan) {
            case '4kmonth1':
                return 'Premium Monthly'
            case '4kannual1':
                return 'Premium Annual'
            case 'hdmonth1':
                return 'Basic Monthly'
            case 'hdannual1':
                return 'Basic Annual'
            default:
                return 'No Active Plan'
        }
    }

    renderPlanInfo = () => {
        const { user, classes } = this.props
        const { InfoItem, UnsubscribeButton, EditButton, ExternalLink } = classes
        if (user.payments.platform === 'free') {
            return <div className={InfoItem} style={{color: 'rgb(150, 150, 150)'}}>
                <span>You are on the Free plan</span><span className={EditButton} onClick={this.signOut}>Sign Out</span>
            </div>
        }

        if (user.payments.platform === 'roku') {
            return <div className={InfoItem} style={{justifyContent: 'center', color: 'rgb(150, 150, 150)'}}>
                <span>You can manage your Spectiv Roku subscription <a href='https://my.roku.com' target='_blank' rel='noopener noreferrer' className={ExternalLink}>here</a></span>
            </div>
        }

        if (user.payments.platform === 'apple') {
            return <div className={InfoItem} style={{justifyContent: 'center', color: 'rgb(150, 150, 150)'}}>
                <span>You can manage your Spectiv Apple subscription <a href='https://buy.itunes.apple.com/WebObjects/MZFinance.woa/wa/DirectAction/manageSubscriptions' target='_blank' rel='noopener noreferrer' className={ExternalLink}>here</a></span>
            </div>
        }

        return [
            <div key='1' className={InfoItem}>
                <span>{this.renderPlanName(user.payments.plan)} {user.payments.expireDate ? <span style={{color: 'rgb(150, 150, 150)'}}>- Expires in {toDays(user.payments.expireDate)} days</span> : null}</span>
                <span>
                    {this.props.user.quality !== 'None' ? <span className={UnsubscribeButton} onClick={this.unsubscribe}>Unsubscribe</span> : null}
                    <span className={classes.PaymentPlanButton} onClick={!this.props.user.payments.cardOnFile ? () => {window.alert('Please add a payment method before selecting your plan')} : this.changePlan}>Change Plan</span>
                </span>
            </div>,
            <div key='2' className={InfoItem}>
                <span style={{position: 'relative', top: '-1rem'}}>{user.payments.card ? this.renderCardType(user.payments.card.brand): null} {user.payments.card ? 'ending in' : null} {user.payments.card ? user.payments.card.lastFour : null}</span>
                <span className={EditButton} onClick={this.changePaymentMethod}>{user.payments.card ? 'Change Method' : 'Add Payment Method'}</span>
            </div>
        ]
    }

    renderPlanInfoMobile = () => {
        const { user, classes } = this.props
        const { InfoItem, UnsubscribeButton, EditButton, ExternalLink } = classes
        if (user.payments.platform === 'free') {
            return <div className={InfoItem} style={{color: 'rgb(150, 150, 150)', justifyContent: 'center', alignItems: 'center'}}>
                <span>You are on the Free plan</span><span className={EditButton} onClick={this.signOut}>Sign Out</span>
            </div>
        }

        if (user.payments.platform === 'roku') {
            return <div className={InfoItem} style={{color: 'rgb(150, 150, 150)', justifyContent: 'center', textAlign: 'center'}}>
                <span>You can manage your Spectiv Roku subscription <a href='https://my.roku.com' target='_blank' rel='noopener noreferrer' className={ExternalLink}>here</a></span>
            </div>
        }

        if (user.payments.platform === 'apple') {
            return <div className={InfoItem} style={{color: 'rgb(150, 150, 150)', justifyContent: 'center', textAlign: 'center'}}>
                <span>You can manage your Spectiv Apple subscription <a href='https://buy.itunes.apple.com/WebObjects/MZFinance.woa/wa/DirectAction/manageSubscriptions' target='_blank' rel='noopener noreferrer' className={ExternalLink}>here</a></span>
            </div>
        }

        return [
            <div key='1' style={{fontSize: '.9rem'}} className={InfoItem}>
                <span>{this.renderPlanName(user.payments.plan)} {user.payments.expireDate ? <span style={{color: 'rgb(150, 150, 150)'}}>- Expires in {toDays(user.payments.expireDate)} days</span> : null}</span>
                <span>
                    {this.props.user.quality !== 'None' ? <span className={UnsubscribeButton} onClick={this.unsubscribe}>Unsubscribe</span> : null}
                    <span className={EditButton}onClick={!this.props.user.payments.cardOnFile ? () => {window.alert('Please add a payment method before selecting your plan')} : this.changePlan}>Change Plan</span>
                </span>
            </div>,
            <div key='2' style={{fontSize: '.9rem'}} className={InfoItem}>
                <span style={{position: 'relative', top: '-1rem'}}>{user.payments.card ? this.renderCardType(user.payments.card.brand): null} {user.payments.card ? 'ending in' : null} {user.payments.card ? user.payments.card.lastFour : null}</span>
                <span className={EditButton} onClick={this.changePaymentMethod}>{user.payments.card ? 'Change Method' : 'Add Payment Method'}</span>
            </div>
        ]
    }    
    
    renderCardType = type => {
        switch (type) {
          case 'Visa':
            return <i className="fab fa-cc-visa" style={{fontSize: '2rem', marginRight: '.5rem'}} data-fa-transform="down-4"/>
          case 'Discover':
            return <i className="fab fa-cc-discover" style={{fontSize: '2rem', marginRight: '.5rem'}} data-fa-transform="down-4"/>
          case 'Mastercard':
            return <i className="fab fa-cc-mastercard" style={{fontSize: '2rem', marginRight: '.5rem'}} data-fa-transform="down-4"/>
          case 'American Express':
            return <i className="fab fa-cc-amex" style={{fontSize: '2rem', marginRight: '.5rem'}} data-fa-transform="down-4"/>
          default:
            break;
        }
    }

    renderMisc = () => {
        const { user, classes } = this.props
        const { Label, InfoItem, EditButton } = classes
        return [
            <div key='1' className={Label}>
                Miscellaneous
            </div>,
            <div key='2' className={InfoItem}>
                {user.payments.platform === 'stripe' ? <span className={EditButton} onClick={this.enterCoupon}>Redeem Coupon</span> : null}
            </div>
        ]
    }
}

const styles = {
    ...flexUtils,
    Body: {
        composes: ['$FlexColumn'],
        justifyContent: 'space-between',
        flex: '1',
        height: '90vh',
        // minHeight: '70vh',
        width: '100%',
        maxWidth: '40rem'
    },
    Label: {
        color: `${Color(palette.blue).lighten(0.5)}`,
        fontWeight: '400',
        marginTop: '2rem',
        padding: '1rem 0rem',
        fontSize: '1rem',
        textAlign: 'center',
        width: '100%',
        borderBottom: '1px solid rgb(200, 200, 200)'
    },
    InfoItem: {
        composes: ['$FlexRow'],
        fontSize: '1rem',
        justifyContent: 'space-between',
        color: palette.white,
        width: '100%',
        padding: '1rem 1rem 1rem 1rem',
        fontWeight: '400'
    },
    InfoItemMobile : {
        extend: 'InfoItem'
    },
    EditButton: {
        color: palette.lightFont,
        fontWeight: '200',
        transition: 'color .5s',
        marginLeft: '1rem',
        '&:hover': {
            color: palette.orange,
            cursor: 'pointer'
        }
    },
    PaymentPlanButton: {
        color: props => props.user.payments.cardOnFile ? palette.lightFont : 'rgb(120, 120, 120)',
        fontWeight: '200',
        transition: 'color .5s',
        marginLeft: '1rem',
        '&:hover': {
            color: props => props.user.payments.cardOnFile ? palette.orange : 'rgb(120, 120, 120)',
            cursor: props => props.user.payments.cardOnFile ? 'pointer' : 'auto'
        }
    },
    UnsubscribeButton: {
        composes: ['$EditButton'],
        color: 'rgb(120, 120, 120)',        
    },
    ExternalLink: {
        color: palette.blue,
        textDecoration: 'none',
        transition: 'color .5s',
        '&:hover': {
            color: `${Color(palette.blue).lighten(1)}`
        }
    },
    Footer: {
        marginTop: '3rem',
        height: '3rem',
        display: 'flex',
        borderRadius: '5px 5px 0 0',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: 'rgba(0, 0, 0, 0.3)'
    },
    FooterGroup: {
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '1rem'
    },
    IconLink: {
        textDecoration: 'none',
        fontSize: '1.5rem',
        color: 'rgb(160, 160, 160)',
        transition: 'color .5s',
        margin: '0rem .3rem',
        '&:hover': {
            color: palette.blue
        }
    },
    Link: {
        composes: '$IconLink',
        fontSize: '1rem',
        textDecoration: 'none'
    },
    autoPlayContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        padding: '1rem'
    },
    slider: {
        transition: 'all .3s',
        display: 'flex',
        alignItems: 'center',
        width: '2vw',
        height: '1vw',
        minHeight: '1rem',
        minWidth: '2rem',
        borderRadius: '50px',
        '&:hover': {
            cursor: 'pointer'
        }
    },
    sliderThumb: {
        transition: 'all .3s',
        transitionTimingFunction: 'ease-out',   
        width: '45%',
        height: '90%',
        borderRadius: '100%',
        backgroundColor: 'green',
        '&:hover': {
            cursor: 'pointer'
        }
    }
}

const mapStateToProps = state => {
    return {
      user: state.mainState.user,
      pending: state.mainState.loggedUserState.pending,
      logged: state.mainState.loggedUserState.logged,
      autoPlay: state.mainState.autoPlay
    }
}

const toDays = timestamp => {
    const now = Math.round(Date.now()/1000)
    const timeLeft = timestamp - now
    return Math.floor(timeLeft/60/60/24)
}

export default withRouter(connect(mapStateToProps)(injectSheet(styles)(AccountInfo)))


// WEBPACK FOOTER //
// ./src/js/Components/Home/AccountInfo.jsx